import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  getLineExecutives,
  lineExecutiveListSuccessful,
  lineExecutiveAddSuccessful,
  areaManagerDropdownSuccessful,
} from "./lineExecutiveSlice";
import { Modal } from "antd";
import { RiCheckboxCircleLine, RiAlertLine } from "react-icons/ri";
import { postAdd, getParamsList, postEdit, postDelete } from "../../../helpers/Helper";

function* fetchLineExecutiveList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = payload.sortOrder + payload.currentSort;
      } else if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/line-executives/", params);
    yield put(lineExecutiveListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddLineExecutive({ payload }) {
  try {
    const obj = { name: payload.name, areamanager_id: payload.areamanager_id };
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/line-executives/", obj);
      if (response.status === 201) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Line Executive Added Successfully!</p>,
        });
        yield put(getLineExecutives({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to add Line Executive!</p>,
        });
      }
    } else {
      const response = yield call(postEdit, "/masters/line-executives/" + payload.id, obj);
      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Line Executive Updated Successfully!</p>,
        });
        yield put(getLineExecutives({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to update Line Executive!</p>,
        });
      }
    }
    yield put(lineExecutiveAddSuccessful());
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* DeleteLineExecutive({ payload }) {
  try {
    const response = yield call(postDelete, "/masters/line-executives/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Line Executive deleted!</p>,
      });
      yield put(getLineExecutives({ page: 1, search: "", page_size: 10 }));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchAreaManagerDropdown({ payload }) {
  try {
    const response = yield call(getParamsList, "/masters/area-managers/", payload);
    yield put(areaManagerDropdownSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* LineExecutiveSaga() {
  yield all([
    fork(function* () { yield takeEvery("lineExecutive/getLineExecutives", fetchLineExecutiveList); }),
    fork(function* () { yield takeEvery("lineExecutive/lineExecutiveAdd", AddLineExecutive); }),
    fork(function* () { yield takeEvery("lineExecutive/lineExecutiveDelete", DeleteLineExecutive); }),
    fork(function* () { yield takeEvery("lineExecutive/getAreaManagerDropdown", fetchAreaManagerDropdown); }),
  ]);
}

export default LineExecutiveSaga;
